/* 通过 qs 模块处理请求数据 */
import axios from 'axios'
import qs from 'qs'
import { headerEncryption } from '@/utils/utils.js'
// create an axios instance
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url，防止跨域请求，此处注释
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000, // request timeout
  crossdomain: true,
})

// service.defaults.withCredentials = true // 若跨域请求需要带 cookie 身份识别
service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // 请求头添加token
    if(localStorage.getItem('token')) {
      config.headers['token'] = localStorage.getItem('token');
      // 请求header头
      config.headers['userid'] = localStorage.getItem('user_id');
      config.headers['t'] = '1620192106';
      config.headers['m'] = headerEncryption('1620192106');
    }

    // post请求解决跨域问题
    if (config.method === 'post') {
      config.data = qs.stringify(config.data)
    }

    // if (store.getters.token) {
    //   // let each request carry token
    //   // ['X-Token'] is a custom headers key
    //   // please modify it according to the actual situation
    //   config.headers['X-Token'] = getToken()
    // }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(

  
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {

    const res = response.data
 
    

    // if the custom code is not 20000, it is judged as an error.
    // if (res.code !== 20000) {
    //   Message({
    //     message: res.message || 'Error',
    //     type: 'error',
    //     duration: 5 * 1000
    //   })

    //   // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //     // to re-login
    //     MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
    //       confirmButtonText: 'Re-Login',
    //       cancelButtonText: 'Cancel',
    //       type: 'warning'
    //     }).then(() => {
    //       store.dispatch('user/resetToken').then(() => {
    //         location.reload()
    //       })
    //     })
    //   }
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
    return res
    // }
  },
  error => {
    // 到登录页重新获取token
    if((error.response.config.url != '/api/account/login') && (error.response.data.exception != 'App\Src\Exception\LoginException')) {
      window.location.href = '/login';
    } 
    return Promise.reject(error)
  } 
)

export default service